export interface OrttoSMS {
  ID: string;
  MarketCountry: string;
  CustomerID: string;
  CampaignName: string;
  SMSBodyID: string;
  CreatedAt: string;
  OrttoSMSStatusUpdates: OrttoSMSStatusUpdate[];
}

export interface OrttoSMSStatusUpdate {
  ID: string;
  OrttoSMSID: string;
  Status: OrttoSMSStatus;
  CreatedAt: string;
  WebhookReceivedAt: string;
}

export enum OrttoSMSStatus {
  Sent = 'sent',
  Delivered = 'delivered',
  Clicked = 'clicked',
  Bounced = 'bounced',
}

export interface OrttoSMSBody {
  ID: string;
  Body: string;
  CreatedAt: string;
  MarketCountry: string;
  CustomerID: string;
}
